import React from 'react';

const SimpleFooter = () => {
  return (
    <footer className="bg-primary py-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center">
          <p className="text-sm text-lightText text-center">
            &copy; 2025 Humaniti Inc. All rights reserved. Patent Pending
          </p>
        </div>
      </div>
    </footer>
  );
};

export default SimpleFooter;
